import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Navbar from 'components/Navbar';

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  const items = state.website.sections ? state.website.sections.map(section => ({ name: section.name, type: section.type })) : [];
  return {
    items,
    logo: state.website.logo,
    isSmallScreen: state.website.ui.winWidth <= 576
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));


// WEBPACK FOOTER //
// ./src/containers/Navbar.container.js